export default __webpack_public_path__ + "static/media/contact_image.c464cf0e.jpg";